'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveByPath as saveCustomWidgetByPath } from 'DesignData/actions/CustomWidgets';
import { getFile, getIsInProjectsFolder } from 'DesignData/selectors/finder';
import { getIsProjectsUngated } from 'DesignData/selectors/gates';
/*
 * Connect()
 */

function makeMapStateToProps() {
  return function mapStateToProps(state, props) {
    const {
      customWidgetId
    } = props;
    const file = getFile(state, {
      fileId: customWidgetId
    });
    return {
      file,
      isInProjectsFolder: !!file && getIsInProjectsFolder(state, {
        folderId: file.folderId
      }),
      isProjectsUngated: getIsProjectsUngated(state)
    };
  };
}

const mapDispatchToProps = {
  stageChanges: saveCustomWidgetByPath
};
/**
 * @function
 */

export default function withProjectsToolbar(Toolbar) {
  /**
   * @class HOC hydrating the Code Editor's toolbar with data and event handlers.
   */
  class WithProjectsToolbar extends Component {
    constructor(...args) {
      super(...args);

      this.onStageChanges = () => {
        this.props.stageChanges(this.props.file);
      };
    }

    /*
     * Render
     */
    render() {
      const {
        isInProjectsFolder,
        isProjectsUngated
      } = this.props;
      return /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(Toolbar, Object.assign({}, this.props, {
          onStageChanges: this.onStageChanges,
          isInProjectsFolder: isInProjectsFolder,
          isProjectsUngated: isProjectsUngated
        }))
      });
    }

  }

  WithProjectsToolbar.displayName = `WithProjectsToolbar(${Toolbar.displayName || Toolbar.name || ''})`;
  WithProjectsToolbar.propTypes = {
    stageChanges: PropTypes.func,
    file: PropTypes.object.isRequired,
    isInProjectsFolder: PropTypes.bool.isRequired,
    isProjectsUngated: PropTypes.bool.isRequired
  };
  return connect(makeMapStateToProps, mapDispatchToProps)(WithProjectsToolbar);
}